var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircledDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0292 25.5C19.9328 25.5 25.5292 19.9036 25.5292 13C25.5292 6.09644 19.9328 0.5 13.0292 0.5C6.12568 0.5 0.529236 6.09644 0.529236 13C0.529236 19.9036 6.12568 25.5 13.0292 25.5Z",
    stroke: "black",
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80962 14.8743C7.8131 14.8743 8.62656 14.0608 8.62656 13.0573C8.62656 12.0538 7.8131 11.2403 6.80962 11.2403C5.80613 11.2403 4.99268 12.0538 4.99268 13.0573C4.99268 14.0608 5.80613 14.8743 6.80962 14.8743Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0276 14.8743C14.0311 14.8743 14.8446 14.0608 14.8446 13.0573C14.8446 12.0538 14.0311 11.2403 13.0276 11.2403C12.0242 11.2403 11.2107 12.0538 11.2107 13.0573C11.2107 14.0608 12.0242 14.8743 13.0276 14.8743Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2461 14.8743C20.2496 14.8743 21.063 14.0608 21.063 13.0573C21.063 12.0538 20.2496 11.2403 19.2461 11.2403C18.2426 11.2403 17.4291 12.0538 17.4291 13.0573C17.4291 14.0608 18.2426 14.8743 19.2461 14.8743Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircledDots);
export default __webpack_public_path__ + "static/media/circled-dots.bfcd258d2853931b3f2ad908a2d1b799.svg";
export { ForwardRef as ReactComponent };